import React from "react";
import { AlertTriangle } from "lucide-react";
import { useT } from "../../lib/lang";

// Iter96 — Phase 2B (spec §8 "Changement de mode"): switching tools
// mid-draw must NOT silently discard placed vertices — confirm first.
export const PlanificationToolSwitchConfirm = ({ onConfirm, onCancel }) => {
  const [t] = useT();
  return (
    <div
      className="absolute inset-0 z-[480] flex items-end sm:items-center justify-center bg-black/50 p-4"
      data-testid="planification-tool-switch-confirm-backdrop"
      onClick={onCancel}
    >
      <div
        className="w-full sm:w-auto sm:min-w-[22rem] bg-[#111418] border border-zinc-700 p-4 flex flex-col gap-3"
        data-testid="planification-tool-switch-confirm"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 text-amber-400">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <span className="text-sm font-semibold">{t.planificationSwitchToolConfirmTitle}</span>
        </div>
        <p className="text-xs text-zinc-400">{t.planificationSwitchToolConfirmMessage}</p>
        <div className="flex items-center justify-end gap-2 pt-1">
          <button
            type="button"
            data-testid="planification-tool-switch-cancel-btn"
            onClick={onCancel}
            className="px-3 py-1.5 text-xs font-medium text-zinc-300 hover:text-white border border-zinc-700 hover:border-zinc-500 transition-colors"
          >
            {t.planificationSwitchToolConfirmCancel}
          </button>
          <button
            type="button"
            data-testid="planification-tool-switch-confirm-btn"
            onClick={onConfirm}
            className="px-3 py-1.5 text-xs font-semibold text-black bg-amber-400 hover:bg-amber-300 transition-colors"
          >
            {t.planificationSwitchToolConfirmOk}
          </button>
        </div>
      </div>
    </div>
  );
};
